<template>
  <header :class="$style.header">
    <div :class="$style.logo">
      <img @click="$router.push('/')" src="/icons/logo.svg" alt="" />
    </div>
    <div @click="logout" :class="$style.logout">
      <img src="/icons/logout.svg" alt="" />
    </div>
  </header>
</template>

<script>
export default {
  methods: {
    async logout() {
      await this.$store.dispatch("deleteToken");
      this.$router.push("/login");
    },
  },
};
</script>

<style lang="scss" module>
.header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 1.25rem 1.5rem;
  background-color: $bg-primary;
  gap: 1rem;
  .logo {
    cursor: pointer;
  }
  .logout {
    cursor: pointer;
  }
}
</style>
